import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "transaction-chain-preceding",
  "use": "transaction-chain-preceding-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"transaction-chain-preceding\">\r\n<path d=\"M9 7.50002L6.5 7.5L5 7.5M9 7.50002L7.73529 6M9 7.50002L7.73529 9\" stroke=\"#C4C4C4\" />\r\n<circle cx=\"3.5\" cy=\"7.5\" r=\"2\" stroke=\"#C4C4C4\" />\r\n<circle cx=\"12.5\" cy=\"7.5\" r=\"2.5\" fill=\"#989A9B\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol